// extracted by mini-css-extract-plugin
export var RecruitMessage = "RecruitMessage-module--RecruitMessage--2yBRd";
export var RecruitMessage__inner = "RecruitMessage-module--RecruitMessage__inner--3QRuz";
export var RecruitMessage__content = "RecruitMessage-module--RecruitMessage__content--2Qc8f";
export var RecruitMessage__title = "RecruitMessage-module--RecruitMessage__title--ItRe6";
export var RecruitMessage__text = "RecruitMessage-module--RecruitMessage__text--1NOy3";